/**
 * #=格式化日期
 * #=创建日期对象
 * #=获取文件完整的URL地址
 * #=通过iframe下载文件
 */

/**
 * #=格式化日期
 * @param {String} date     日期对象或字符串
 * @param {String} format   格式化字符串yy-MM-dd
 * @returns {String}
 */
export function dateFormat (date, format = 'yyyy-MM-dd') {
  if (!date) return date
  date = createDate(date)
  const o = {
    'M+': date.getMonth() + 1, // month
    'd+': date.getDate(), // day
    'h+': date.getHours(), // hour
    'm+': date.getMinutes(), // minute
    's+': date.getSeconds(), // second
    'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
    S: date.getMilliseconds()
    // millisecond
  }
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + '')
      .substr(4 - RegExp.$1.length))
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k])
        .substr(('' + o[k]).length))
    }
  }
  return format
}

/**
 * #=创建日期对象
 * @param {String} date 日期字符串，数字时间，日期对象
 */
function createDate (date) {
  if (!date) return date
  switch (typeof date) {
    case 'string':
      return new Date(date.replace(/-/g, '/').replace(/T|Z/g, ' ').trim())
    case 'number':
      return new Date(date)
    default:
      return date
  }
}

/**
 * #=获取文件完整的URL地址
 * @param {String} fileUrl 文件名
 * @returns {string}
 */
export function getFileFullUrl (fileUrl) {
  return process.env.VUE_APP_FILE_API + '/' + fileUrl
}

/**
 * #=通过iframe下载文件
 * @param {string} url     网址
 * @param url
 */
export function downloadFile (url) {
  try {
    const elemIF = document.createElement('iframe')
    elemIF.src = url
    elemIF.style.display = 'none'
    elemIF.onload = function (event) {
      document.body.removeChild(elemIF)
    }
    elemIF.onerror = function (event) {
      console.log('下载失败!')
    }
    document.body.appendChild(elemIF)
  } catch (e) {
  }
}

export default {
  dateFormat,
  getFileFullUrl,
  downloadFile
}
